import React from "react";
import { useResolveTransactionMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import SelectInput from "../../../Common/components/select-input";
import TextInput from "../../../Common/components/text-input";

const ResolveTransactionModal = ({ showResolveTransactionModal, onHide, details, tableRef }) => {
    console.log(details);

    const [resolveTransaction, { isLoading: isUpdating }] = useResolveTransactionMutation();

    // Determine resolution options based on transaction type
    let resolutionOptions = [
        "Account Debit", "Account Credit", "Balance Revalidation Required", "Reverse Intra Transfer In Transaction",
        "Reverse Intra Transfer Out Transaction","Duplicate Transaction Resolution - Debit",
        "Tech Support"
    ];

    if (details?.stalledTransactionType === "WITHDRAW") {
        resolutionOptions = [
            "Payment Reprocessed",
            "Payment Reversed",
            "Payment Revalidation Required",
            "Tech Support"
        ];
    } else if (details?.stalledTransactionType === "BUY") {
        resolutionOptions = [
            "No Further Action Required",
            "Account Debit",
            "Forced Asset Liquidation for Corresponding Buy Order",
            "Tech Support"
            
        ];
    } else if (details?.stalledTransactionType === "SELL") {
        resolutionOptions = [
            "No Further Action Required",
            "Account Debit",
            "Forced Asset Liquidation for Corresponding Sell Order",
            "Tech Support"
        ];
    }

    const onSubmit = (values) => {
        resolveTransaction({
            autoId: details?.autoId,
            comment: details?.comment,
            status: details?.status,
            flaggedId: details?.flaggedId,
            ...values,
        })
            .unwrap()
            .then(() => {
                tableRef.current.refresh();
                cogoToast.success("Resolve Transaction Action Created Successfully");
                onHide();
            });
    };

    return (
        <Modal
            show={showResolveTransactionModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={{
                    resolutionType: "",
                    resolutionComment: "",
                }}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Resolve Transaction Modal
                            </Modal.Title>
                            <button type="button" className="close" onClick={onHide}>
                                <span aria-hidden="true" className="d-block">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                            <FormLayout.Row>
                                <SelectInput
                                    label="Resolution Type*"
                                    name="resolutionType"
                                    options={resolutionOptions}
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Comment"
                                    name="resolutionComment"
                                />
                            </FormLayout.Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                disabled={isUpdating}
                                className="btn btn-light btn-elevate px-4"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isUpdating}
                                className="btn btn-primary btn-elevate px-4 ml-4"
                            >
                                Submit
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default ResolveTransactionModal;
